


















import { DraftCompanyParams } from '@/store/interfaces/drafts';
import drafts from '@/store/types/drafts';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import InboundCard from './inboundCard.vue';
import imagePreview from '@/components/Reusable/imagePreview.vue';
import document from '@/store/types/document';
import { DocumentKindParams } from '@/store/interfaces/document';
import { VuexFunction } from '@/ts/axios';
import { responseDataPagination } from '@/store/interfaces/json-api/generics';
import documentUpdateForm from './forms/documents.vue';

@Component({
  components: { InboundCard, imagePreview, documentUpdateForm, },
})
export default class Documents extends Vue {
  loadingKindOfDocument = true;
  async mounted(): Promise<void> {
    await this.listDocumentKind();
    this.loadingKindOfDocument = false;
  }

  @Getter(`documentModule/${document.getters.GET_DOCUMENT_KIND}`)
  getlistDocumentKind!: responseDataPagination<DocumentKindParams>;

  @Action(`documentModule/${document.actions.LIST_DOCUMENT_KIND}`)
  listDocumentKind!: VuexFunction<responseDataPagination<DocumentKindParams>>;

  @Getter(`drafts/${drafts.getters.GET_DRAFT_COMPANY}`)
  draftCompany!: DraftCompanyParams;
}
